<router-outlet></router-outlet>
<!-- The site's own alert / confirm / prompt (shared/dialogs/app-dialog.ts), in place of the browser's. -->
<app-dialog-host></app-dialog-host>
<!-- Talk to us's pop-up on the seller pages (TalkService), here so nothing on the page can sit above it. -->
<app-talk-dialog></app-talk-dialog>
<!-- The site in the visitor's language, offered once the cookie notice is answered - one note at a time - and only in the
     browser: never part of the server's HTML. -->
<app-culture-suggest *ngIf="inBrowser && cookieAccepted" [country]="visitorCountry"></app-culture-suggest>
<div class="button-bar" *ngIf="!cookieAccepted"> 
    <div>{{ 'cookie-notice' | t:'We use cookies to personalise content and ads and to provide social media features, analyse our traffic and to ensure you get the best experience on our website.' }}
        <a href="/privacy" target="_blank">{{ 'about-cookies' | t:'About Cookies' }}</a>
    </div>
    <button (click)="cookieAccept()" class="btn btn-primary">{{ 'got-it' | t:'Got It!' }}</button>
</div>
